<div class="dead-link-wrapper">
  <div class="grid-row">
    <figure class="content-card-wrapper">
      <img src="../../../../assets/images/coming-soon.jpg" alt="coming-soon" />
      <router-outlet></router-outlet>
    </figure>
  </div>
</div>
